/**
 * @generated SignedSource<<7fe36a76d228247608d8e95621c55dd9>>
 * @relayHash 3e8bd30f306856a7069ecf9a78e5304d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2e26a3347c1a3aaf2d76c79a7e2474e3a6b25afacbd327168552fcffcb23de08

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "2e26a3347c1a3aaf2d76c79a7e2474e3a6b25afacbd327168552fcffcb23de08",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
